import { DownloadDocumentType } from '@commenda/types';

export async function downloadDocumentLocally({
  fileName,
  fileType,
  blob,
  onDownload,
}: {
  fileName: string;
  fileType: DownloadDocumentType;
  blob: Blob;
  onDownload?: () => Promise<void>;
}) {
  // image extensions are so many, so we need to get the extension from the file name.
  const extension = fileType === 'image' ? fileName.split('.').pop() : fileType;

  // Create a temporary link element
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.${extension}`; // Set the filename

  // Append link to body, click it, and remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL
  window.URL.revokeObjectURL(link.href);

  if (onDownload) {
    await onDownload();
  }
}
